import { NavLink } from 'react-router-dom'
import { Home, FileText, Users, User, Package, ArrowRightLeft } from 'lucide-react'

/**
 * Bottom Navigation Component
 * Mobile-first navigation with 6 main tabs
 */
const BottomNav = () => {
  // Navigation items configuration
  const navItems = [
    {
      path: '/',
      icon: Home,
      label: 'الرئيسية',
      exact: true,
    },
    {
      path: '/invoices',
      icon: FileText,
      label: 'الفواتير',
    },
    {
      path: '/inventory',
      icon: Package,
      label: 'المخزون',
    },
    {
      path: '/transfers',
      icon: ArrowRightLeft,
      label: 'التحويلات',
    },
    {
      path: '/customers',
      icon: Users,
      label: 'العملاء',
    },
    {
      path: '/profile',
      icon: User,
      label: 'حسابي',
    },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bottom-nav-height">
      {/* Gradient Background with Glassmorphism */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600"></div>
      <div className="absolute inset-0 bg-white/10 backdrop-blur-md"></div>
      <div className="absolute inset-0 border-t border-white/20"></div>

      <div className="relative flex items-center justify-around h-full px-2">
        {navItems.map((item) => (
          <NavItem
            key={item.path}
            path={item.path}
            icon={item.icon}
            label={item.label}
            exact={item.exact}
          />
        ))}
      </div>

      {/* Safe area spacer for iOS */}
      <div className="h-safe-bottom bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600" />
    </nav>
  )
}

/**
 * Individual Navigation Item
 */
const NavItem = ({ path, icon: Icon, label, exact = false }) => {
  return (
    <NavLink
      to={path}
      end={exact}
      className={({ isActive }) =>
        `relative flex flex-col items-center justify-center min-w-[64px] py-2 px-3 rounded-xl transition-all duration-300 touch-target ${
          isActive
            ? 'bg-white/20 backdrop-blur-sm shadow-lg'
            : 'hover:bg-white/10'
        }`
      }
    >
      {({ isActive }) => (
        <>
          <Icon
            className={`w-6 h-6 transition-all duration-300 ${
              isActive ? 'scale-110 text-white drop-shadow-lg' : 'scale-100 text-white/80'
            }`}
            strokeWidth={isActive ? 2.5 : 2}
          />
          <span
            className={`text-xs mt-1 transition-all duration-300 ${
              isActive ? 'font-semibold text-white' : 'font-normal text-white/80'
            }`}
          >
            {label}
          </span>
          {/* Active indicator - glowing dot */}
          {isActive && (
            <div className="absolute -top-1 w-2 h-2 bg-yellow-400 rounded-full shadow-lg shadow-yellow-400/50 animate-pulse" />
          )}
        </>
      )}
    </NavLink>
  )
}

export default BottomNav
